import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { productDescriptions } from "./data/plans";
import { auth } from "./firebase";
import { getIdToken } from "firebase/auth";
import axios from "axios";

function Pricing() {
    const navigate = useNavigate();

    //IF WHOLE PAYMENT PROCESS IS ON OUR SIDE
    const handleBuyClick = (planId) => {
        navigate(`/purchase?planId=${planId}`);
    };

    // Filter credit-type plans only
    const creditPlans = Object.entries(productDescriptions)
        .filter(([id, plan]) => plan.type === "credit")
        .map(([id, plan]) => ({ id, ...plan }));


    //IF PAYMENT PROCESS HANDLES STRIPE
    const handleCheckout = async (planId, unitPrice) => {

        const user = auth.currentUser;
        const email = user.email;
        if (!user) return;

        try {
            const token = await getIdToken(user, true); // get fresh token
            const res = await axios.post(process.env.REACT_APP_API_URL+"/create-checkout-session",
            { planId, email, unitPrice},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            window.location.href = res.data.url; // redirect to Stripe Checkout
        } catch (err) {
            console.error("Checkout error:", err);
        }
    };

    return (
        <div className="pricing-table-container">
            <div className="pricing-header">
                <h2>Pay for what you need</h2>
                <p>No monthly payments • Pay for what you need • Stripe supported</p>
            </div>

            <div className="pricing-table">
                {creditPlans.map((plan) => (
                    <div key={plan.id} className="pricing-row">
                        <div className="plan-quantity">{plan.amount} Credits</div>
                        <div className="plan-price"><strong>{plan.price}</strong></div>
                        <div className="plan-unit">{plan.unitPrice ?? "$0.00100"} / email</div>
                        <div className="plan-save">{plan.saveText ?? "Save XX%"}</div>
                        <button className="buy-btn" onClick={() => handleCheckout(plan.id, plan.unitPrice)}>BUY NOW</button>
                    </div>
                ))}
            </div>

            <div className="payment-logos">
                {/*<img src="/visa.svg" alt="Visa" />*/}
                {/*<img src="/mastercard.svg" alt="Mastercard" />*/}
                {/* Add more logos as needed */}
            </div>
        </div>
    );
}

export default Pricing;